'use client'

import { IPopup, Language } from '@/lib/interfaces/interfaces'
import { Dialog, DialogContent, Typography, Box, Divider } from '@mui/material'
import Image from 'next/image'
import React, { useState, useEffect } from 'react'
import { X } from 'lucide-react' // Importa el icono X
import { useSearchParams, usePathname } from 'next/navigation'
import { roboto } from '@/lib/fonts'

interface Props {
  popup: IPopup;
  language: Language;
}

const MenuPopup = ({ popup, language }: Props) => {
  const [open, setOpen] = useState(popup.isActive)
  const searchParams = useSearchParams()
  const path = usePathname()

  useEffect(() => {
    // Si el menú es el de muestra, mostrar el popup solo si el tiene el param
    // if (path === '/menu/barcraft') {
    //   const showPopup = searchParams.get('popup') === 'true'
    //   setOpen(showPopup && popup.isActive)
    // } else {
    //   setOpen(popup.isActive)
    // }
    setOpen(popup.isActive)
  }, [path, popup.isActive, searchParams])

  // Extraer título y texto según el idioma
  const title = popup[`title_${language}`] || ''
  const bodyText = popup[`bodyText_${language}`] || ''
  const imgUrl = popup.img?.url || ''

  return (
    <Dialog
      open={open}
      onClose={() => setOpen(false)}
      sx={{
        '& .MuiDialog-paper': {
          borderRadius: '10px',
          maxWidth: '400px',
          width: '90%',
          position: 'relative' // Necesario para posicionar el botón de cierre
        }
      }}
    >
      {/* Botón de cierre superpuesto */}
      <span
        onClick={() => setOpen(false)}
        style={{
          position: 'absolute',
          top: '10px',
          right: '10px',
          cursor: 'pointer',
          background: '#fff',
          border: 'none',
          padding: '0px',
          margin: '0px',
          zIndex: 20,
          color: 'gray',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: '30px',
          height: '30px',
          borderRadius: '50%'
        }}
        aria-label='Cerrar popup'
      >
        <X size={24} />
      </span>

      {/* Imagen encima del título */}
      {imgUrl && (
        <Box
          sx={{
            width: '100%',
            position: 'relative'
          }}
        >
          <Image
            src={imgUrl}
            alt={title || 'Imagen del Popup'}
            layout='responsive'
            width={600}
            height={400}
            objectFit='contain'
            loading='lazy'
          />
        </Box>
      )}

      {(title || bodyText) &&
        <DialogContent sx={{ paddingBottom: '20px', overflow: 'visible' }}>
          {title &&
            <Typography textAlign='center' variant='h5' gutterBottom>
              {title}
            </Typography>}
          {!imgUrl && title && bodyText && <Divider sx={{ marginBottom: '20px', marginTop: '10px' }} />}
          {
            bodyText &&
              <Box textAlign='center' sx={{ color: 'text.secondary', whiteSpace: 'pre-line' }}>
                <div style={roboto.style}>{bodyText}</div>
              </Box>
          }
        </DialogContent>}
    </Dialog>
  )
}

export default MenuPopup
